exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.produced-quantity[data-v-11970e72] {\n    width: 3rem;\n    margin: auto;\n}\n.foot-cell[data-v-11970e72] {\n    height: 7rem;\n}\n", ""]);

// exports
